import gql from 'graphql-tag';

export default gql`
    mutation UpdateLoadFieldOpDetail($input: LoadDetailFieldOpEdit) {
        updateLoadFieldOpDetail(input: $input) {
            errors
        }
    }
`;
